import { z } from 'zod';

import { SEX } from '@/constants';

const shipmentSchema = z.object({
  id: z.string().uuid(),
  shipmentNumber: z.string().optional(),
  shipName: z.string().optional(),
});

export const createEditSemenFormSchema = (isConditionalValidation: boolean) => {
  const sharedSchema = z.object({
    dateReceived: z.date({ required_error: 'Date Received is required' }),
    colCode: z.string().min(1, 'Col Code is required'),
    quantityReceived: z.number().int().min(1, 'Quantity Received is required'),
    cane: z.string().optional(),
    naab: z.string().optional(),
    sexed: z.enum(['Yes', 'No']).optional(),
    cssCertified: z.number().int().nullish(),
    export: z.number().int().nullish(),
    center: z.string().optional(),
    shortName: z.string().optional(),
    quantity: z.number().int().optional(),
    quantityToShip: z.number().int().optional(),
    soldTo: z.string().optional(),
    sortStatus: z.number().int().optional(),
    comment: z.string().optional(),
    critical: z.number().int().optional(),
    storageStartDate: z.date().optional(),
    secondaryOwner: z.string().optional(),
    cost: z.number().optional(),
    shipment: shipmentSchema.or(z.string().uuid()).optional(),
    semenType: z.string().optional(),
    units: z.number().int().optional(),
    country: z.string().optional(),
  });

  if (isConditionalValidation) {
    return sharedSchema
      .extend({
        sex: z.number().int().optional(),
      })
      .refine(
        (data) =>
          (data.sex !== SEX.Male && data.sex !== SEX.Female) ||
          Boolean(data.naab?.length),
        {
          path: ['naab'],
          message: 'NAAB is required',
        },
      );
  }

  return sharedSchema.extend({
    sex: z.number().int().optional(),
  });
};

export const editSemenFormSchema = createEditSemenFormSchema(false);
